import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Card,
  CardBody
} from 'reactstrap';
import ReactLoading from 'react-loading';
import './ModalStyles.css';
import './CustomerDetailModal.css';
import './ServiceRecordModal.css';

class CustomerDetailModal extends React.Component {
  componentDidMount() {
    // Ensure body scroll is enabled when component mounts
    document.body.style.overflow = 'unset';
  }

  componentWillUnmount() {
    // Remove any modal-related classes and restore scroll
    document.body.classList.remove('modal-open');
    document.body.style.overflow = 'unset';
    document.body.style.paddingRight = '';
    
    // Remove any lingering modal backdrops
    const backdrops = document.querySelectorAll('.modal-backdrop');
    backdrops.forEach(backdrop => backdrop.remove());
  }

  handleModalClosed = () => {
    // Ensure scroll is restored when modal closes
    setTimeout(() => {
      document.body.classList.remove('modal-open');
      document.body.style.overflow = 'unset';
      document.body.style.paddingRight = '';
    }, 300);
  };

  render() {
    const {
      isOpen,
      toggle,
      formData,
      cities,
      districts,
      customerLoading,
      userHasUpdatePermission,
      handleChange,
      handleCityChange,
      handleSubmit,
      checkTaxPayer
    } = this.props;
    const customerName = [formData.customerData.name, formData.customerData.surname]
      .filter(Boolean)
      .join(' ') || 'Müşteri kaydı';
    const customerInitials = customerName
      .split(' ')
      .slice(0, 2)
      .map(part => part.charAt(0).toLocaleUpperCase('tr-TR'))
      .join('');

    return (
      <Modal 
        isOpen={isOpen} 
        toggle={toggle} 
        size="lg" 
        id="customer-container"
        onClosed={this.handleModalClosed}
        className="modern-modal service-record-modal customer-record-modal"
        backdrop="static"
        fade={true}
        centered
      >
        <ModalHeader toggle={toggle} className="modal-header-gradient">
          <div className="modal-title-wrapper">
            <div className="modal-icon-wrapper">
              <i className="fa fa-user"></i>
            </div>
            <div>
              <span className="srm-eyebrow">MÜŞTERİ KAYDI</span>
              <h5 className="mb-0">{customerName}</h5>
              <small>İletişim ve fatura bilgilerini düzenleyin</small>
            </div>
          </div>
        </ModalHeader>
        <ModalBody className="modal-body-modern">
          <div className="srm-identity-card">
            <div className="srm-avatar">{customerInitials || 'M'}</div>
            <div className="srm-identity-copy">
              <small>MÜŞTERİ</small>
              <strong>{customerName}</strong>
              <span>{formData.customerData.title || 'Bireysel müşteri'}</span>
            </div>
            <div className="srm-identity-meta">
              <span><i className="fa fa-phone" /> {formData.customerData.phone || 'Telefon belirtilmedi'}</span>
              <span><i className="fa fa-envelope-o" /> {formData.customerData.email || 'E-posta belirtilmedi'}</span>
            </div>
          </div>
          <Form id="customerData" onSubmit={handleSubmit}>
            <Card className="info-card mb-3">
              <CardBody>
                <h6 className="section-title">
                  <i className="fa fa-address-card-o" /> Temel bilgiler
                </h6>

                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <Label for="is_supplier" className="modern-label">
                        Müşteri Tipi
                      </Label>
                      <Input
                        type="select"
                        name="customerData.is_supplier"
                        id="is_supplier"
                        value={formData.customerData.is_supplier}
                        onChange={handleChange}
                        className="modern-input"
                      >
                        <option value="">Tip Seçiniz</option>
                        <option value="0">Müşteri</option>
                        <option value="1">Tedarikçi</option>
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="name" className="modern-label">
                        Adı *
                      </Label>
                      <Input
                        type="text"
                        name="customerData.name"
                        id="name"
                        placeholder="Ad giriniz"
                        value={formData.customerData.name}
                        onChange={handleChange}
                        className="modern-input"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="surname" className="modern-label">
                        Soyadı *
                      </Label>
                      <Input
                        type="text"
                        name="customerData.surname"
                        id="surname"
                        placeholder="Soyad giriniz"
                        value={formData.customerData.surname}
                        onChange={handleChange}
                        className="modern-input"
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="phone" className="modern-label">
                        Telefon
                      </Label>
                      <Input
                        type="text"
                        name="customerData.phone"
                        id="phone"
                        placeholder="05XX XXX XX XX"
                        value={formData.customerData.phone}
                        onChange={handleChange}
                        className="modern-input"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="email" className="modern-label">
                        E-posta
                      </Label>
                      <Input
                        type="email"
                        name="customerData.email"
                        id="email"
                        placeholder="ornek@email.com"
                        value={formData.customerData.email}
                        onChange={handleChange}
                        className="modern-input"
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <Label for="city_id" className="modern-label">
                        İl
                      </Label>
                      <Input
                        type="select"
                        name="customerData.city_id"
                        id="city_id"
                        value={formData.customerData.city_id}
                        onChange={handleCityChange}
                        className="modern-input"
                      >
                        <option value="">İl Seçiniz</option>
                        {cities && cities.map(city => (
                          <option key={city.id} value={city.id}>
                            {city.name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <Label for="district_id" className="modern-label">
                        İlçe
                      </Label>
                      <Input
                        type="select"
                        name="customerData.district_id"
                        id="district_id"
                        value={formData.customerData.district_id}
                        onChange={handleChange}
                        className="modern-input"
                      >
                        <option value="">İlçe Seçiniz</option>
                        {districts && districts.map(district => (
                          <option key={district.id} value={district.id}>
                            {district.name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>

              </CardBody>
            </Card>

            <Card className="info-card mb-3">
              <CardBody>
                <h6 className="section-title">
                  <i className="fa fa-building-o" /> Şirket ve fatura bilgileri
                </h6>

                <FormGroup>
                  <Label for="title" className="modern-label">
                    Ünvan
                  </Label>
                  <Input
                    type="text"
                    name="customerData.title"
                    id="title"
                    placeholder="Ünvan giriniz"
                    value={formData.customerData.title}
                    onChange={handleChange}
                    className="modern-input"
                  />
                </FormGroup>

                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="tax_no" className="modern-label">
                        Vergi / TC No
                      </Label>
                      <Input
                        type="number"
                        name="customerData.tax_no"
                        id="tax_no"
                        placeholder="11 haneli numara"
                        value={formData.customerData.tax_no}
                        onChange={handleChange}
                        className="modern-input"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="tax_district" className="modern-label">
                        Vergi Dairesi
                      </Label>
                      <Input
                        type="text"
                        name="customerData.tax_district"
                        id="tax_district"
                        placeholder="Vergi dairesi adı"
                        value={formData.customerData.tax_district}
                        onChange={handleChange}
                        className="modern-input"
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="urn" className="modern-label">
                        E-Fatura Urn Adresi (Etiket)
                      </Label>
                      <Input
                        type="text"
                        name="customerData.urn"
                        id="urn"
                        placeholder="urn:mail:example@domain.com"
                        value={formData?.customerData?.urn ? formData.customerData.urn : ''}
                        onChange={handleChange}
                        className="modern-input"
                      />
                      <small className="text-muted">
                        * Mükellef doğrulama ile otomatik doldurulur veya manuel girebilirsiniz
                      </small>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="invoice_type" className="modern-label">
                        Fatura Tipi
                      </Label>
                      <Input
                        type="select"
                        name="customerData.invoice_type"
                        id="invoice_type"
                        value={formData?.customerData?.invoice_type ? formData.customerData.invoice_type : 'EARSIV'}
                        onChange={handleChange}
                        className="modern-input"
                      >
                        <option value="EARSIV">E-Arşiv</option>
                        <option value="EFATURA">E-Fatura</option>
                      </Input>
                      <small className="text-muted">
                        * Mükellef doğrulama ile otomatik seçilir
                      </small>
                    </FormGroup>
                  </Col>
                </Row>

                <FormGroup>
                  <Label for="address" className="modern-label">
                    Adres
                  </Label>
                  <Input
                    type="textarea"
                    name="customerData.address"
                    id="address"
                    placeholder="Açık adres giriniz..."
                    value={formData.customerData.address}
                    onChange={handleChange}
                    rows={3}
                    className="modern-input"
                  />
                </FormGroup>
              </CardBody>
            </Card>

          </Form>
        </ModalBody>
        <ModalFooter className="modal-footer-modern">
          <Button 
            color="light" 
            onClick={(e) => {
              e.stopPropagation();
              toggle();
            }}
            className="modern-btn-secondary"
          >
            <i className="fa fa-times mr-2"></i>
            Kapat
          </Button>
          <div className="srm-footer-actions">
            {formData.customerData.tax_no && String(formData.customerData.tax_no).trim() !== '' && (
              <Button
                color="warning"
                onClick={(e) => {
                  e.stopPropagation();
                  checkTaxPayer();
                }}
                type="button"
                className="modern-btn btn-gradient-warning"
              >
                <i className="fa fa-check-circle mr-2"></i>
                Mükellef doğrula
              </Button>
            )}
            {customerLoading ? (
              <Button color="primary" disabled className="modern-btn btn-gradient-primary">
                <ReactLoading type="spin" width={'17px'} height={'17px'} color="#ffffff" className="d-inline-block mr-2" />
                Kaydediliyor...
              </Button>
            ) : (
              <Button color="primary" type="submit" form="customerData" disabled={!userHasUpdatePermission} className="modern-btn btn-gradient-primary">
                <i className="fa fa-save mr-2"></i>
                Değişiklikleri kaydet
              </Button>
            )}
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

export default CustomerDetailModal;
